import React, {Component} from 'react';

import Button from '../../components/UI/Buttons/Button/Button';
import Aux from '../hoc/Auxiliary';
import Input from '../../components/UI/Input/Input';
import FlashModal from '../../components/UI/Modal/FlashEmailModal/FlashEmailModal';

import axios from '../../axios-drops';
import facebookIcon from '../../icons/facebook-sketched-logo-variant.svg';
import instagramIcon from '../../icons/instagram-sketched-logo.svg';
import SvgIcon from '../../components/UI/SvgIcon/SvgIcon';

import classes from './EmailSignupForm.css';

class EmailSignupForm extends Component {

    state = {
        inputForm: {
            email: {
                elementType: 'input', 
                elementConfig: {
                    type: 'email',
                    placeholder: ''
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false,
                name: 'Email Address'
            }
        },
        formIsValid: false,
        loading: false,
        ip: null,
        showModal: false,
        showFlashModal: false
    }


  

    componentDidMount() {
        axios.get('https://api64.ipify.org?format=jsonp?callback=?')
        .then( res => {
            this.setState({ip: res.data})
        })
    }


    notSignedUpCheck = () => {  // to use later or not we will see 
        return true
    }

    saveClickedHandler = async () => {

        if (this.notSignedUpCheck()) {
            const subscribe = {
                ip: this.state.ip,
                email: this.state.inputForm.email.value
            }


            await axios.post('/email-list.json', subscribe)
                .then(response => {
                    // console.log(response)
                    this.clearFormValues()
                    // show thanks for subscribing modal
                    this.showModalMessage()
                    // get out of email modal 
                }).catch(error => console.log(error));
        } else {
            // display modal - already signed up 
        }
    }

    showModalMessage = () => {
        // alert("copied")
        this.setState({showFlashModal: true})

        setTimeout(() => {
            this.setState({showFlashModal: false})
               
        }, 1500)
    }


    clearFormValues = () => {
        const updatedInputForm = {
            ...this.state.inputForm
        }

        const updatedFormEmail = {
            ...updatedInputForm.email
        }

        updatedFormEmail.value = '';
        updatedFormEmail.valid = false;
        updatedFormEmail.touched = false;

        updatedInputForm.email = updatedFormEmail;

        this.setState({inputForm: updatedInputForm,
                        formIsValid: false})

    }

 

    checkValidity(value, rules) {
        
        let isValid = true;

        if(rules.required){
            isValid = value.trim() !== '';     
        }

        if ( rules.isEmail ) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test( value ) && isValid
        }

        return isValid;
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedInputForm = {
            ...this.state.inputForm
        }


        const updatedFormElement = {
            ...updatedInputForm[inputIdentifier]
        }

        // console.log(updatedFormElement)
        updatedFormElement.value = event.target.value;

        // console.log(updatedFormElement)

        updatedFormElement.valid = this.checkValidity(
            updatedFormElement.value, updatedFormElement.validation
        )
        updatedFormElement.touched = true;
        // console.log(updatedFormElement);

        updatedInputForm[inputIdentifier] = updatedFormElement;
        // console.log(updatedInputForm)
        let formIsValid = true;
        for( let inputIdentifier in updatedInputForm){
            formIsValid = updatedInputForm[inputIdentifier].valid
            && formIsValid;
        }

        this.setState({inputForm: updatedInputForm,
                        formIsValid: formIsValid});

    }

    render() {

        const formElementsArray = [];
        for (let key in this.state.inputForm){
            formElementsArray.push({
                id: key,
                config: this.state.inputForm[key]
            })
        }

        let form = (
            <Aux>
                {formElementsArray.map(formElement => (
                    <Input key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)}
                        name={formElement.config.name}/>
                ))}
            </Aux>
            )
//clicked={this.saveClickedHandler}
        return (
            <div className={classes.EmailSignupForm}>
                <h3>Diverse Medium Designs</h3>
                <h3>Mailing List</h3>
                <p className={classes.Text}>By signing up you are agreeing to receive email messages from us. They will include
                    but not be limited to Giveaways, Product Announcements, Special Email-only promotions, 
                    Limited Edition Email Drops, and Beta testing of new products!
                </p>
                {form}
                <Button btnType="Submit" disabled={!this.state.formIsValid} clicked={this.saveClickedHandler}> 
                    Subscribe
                </Button>
                <div className={classes.SocialMediaArea}>
                    <div className={classes.Icon}>
                        <SvgIcon icon={facebookIcon} url={'https://www.facebook.com/groups/DiverseMediumDesigns'} />
                    </div>
                    <div className={classes.Icon}>
                        <SvgIcon icon={instagramIcon} url={'https://www.instagram.com/diverse_medium/?hl=en'} />
                    </div>
                </div>
                <div className={classes.SocialMessage}>
                    <p className={classes.Text}>Join our Instagram and Facebook by following the links above.</p>
                </div>
                <FlashModal show={this.state.showFlashModal}>Thanks for Subscribing!</FlashModal>
            </div>
        )
    }
}

export default EmailSignupForm


// WEBPACK FOOTER //
// ./src/containers/EmailSignupForm/EmailSignupForm.js